// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevInputMaskController {
	/* @ngInject */
	constructor() {
		this.data = 13_620.59;
		this.settings = {
			format:             Number,
			mapToRadix:         ['.'],
			max:                100_000,
			min:                -100_000,
			normalizeZeros:     true,
			radix:              ',',
			scale:              2,
			signed:             false,
			thousandsSeparator: ' ',
		};
	}
}
